@if (dataSource) {
<mat-grid-list
    cols="1"
    rowHeight="120px"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container no-padding justify-center">
            <div class="wrapper widget-full-width-height-2">
                @for (item of dataSource.indicatorOptions; track item) {
                <app-mdr-dashboards-indicator [element]="item"></app-mdr-dashboards-indicator>
                }
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource && !mdrDashboardsService.isLcoCompany(organization)) {
<mat-grid-list
    cols="3"
    rowHeight="262px"
    class="m-t-16"
    gutterSize="16"
>
    <mat-grid-tile colspan="2">
        <div class="bordered-container align-center">
            <div class="bar-chart-main">
                <app-mdr-dashboards-bar-chart
                    [colors]="dataSource.alertsByOS.colors"
                    [width]="'100%'"
                    [height]="180"
                    [scaleLegend]="true"
                    [tooltipWidth]="168"
                    [element]="dataSource.alertsByOS"
                    [showXaxisLabels]="true"
                    [hasMarginTop]="false"
                    [columnWidth]="'35%'"
                    [emptyText]="'There are no ongoing alerts'"
                    [categories]="dataSource.alertsByOS.categories"
                ></app-mdr-dashboards-bar-chart>
            </div>
        </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="1">
        <div class="bordered-container align-center">
            <div class="bar-chart-main">
                @if (dataSource.endpointsByOS.data) {
                <app-mdr-dashboards-pie-chart
                    [element]="dataSource.endpointsByOS"
                    [colors]="dataSource.endpointsByOS.colors"
                    [strokeWidth]="4"
                    [donutSize]="'83%'"
                    [width]="150"
                    [height]="190"
                    [tableLegend]="true"
                    [mainContainerWidth]="'100%'"
                    [pieWidthCoverage]="'60%'"
                ></app-mdr-dashboards-pie-chart>
                }
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource && !mdrDashboardsService.isLcoCompany(organization)) {
<mat-grid-list
    cols="3"
    rowHeight="398"
    class="m-t-16"
    gutterSize="16"
>
    <mat-grid-tile colspan="1">
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.topEndpointsByAlerts"
                [mocked]="false"
                [displayedColumns]="dataSource.topEndpointsByAlerts.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="2">
        <div class="bordered-container align-center">
            <div class="chart-container">
                <app-mdr-dashboards-area-chart
                    [element]="dataSource.endpointsByOsTrend"
                    [tooltipWidth]="176"
                    [fillType]="'solid'"
                    [yaxisLogarithmicScale]="false"
                    [strokeCurve]="'straight'"
                    [fillOpacity]="0"
                    [tableLegend]="false"
                    [strokeWidth]="3"
                    [emptyStateTitle]="'No data available'"
                    [legendDisplayedColumns]="['name']"
                    [colors]="dataSource.endpointsByOsTrend.colors"
                ></app-mdr-dashboards-area-chart>
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource && mdrDashboardsService.isLcoCompany(organization)) {
<mat-grid-list
    cols="3"
    rowHeight="398"
    class="m-t-16"
    gutterSize="16"
>
    <mat-grid-tile colspan="2">
        <div class="bordered-container align-center">
            <div class="chart-container">
                <app-mdr-dashboards-area-chart
                    [element]="dataSource.endpointsByOsTrend"
                    [tooltipWidth]="176"
                    [fillType]="'solid'"
                    [yaxisLogarithmicScale]="false"
                    [strokeCurve]="'straight'"
                    [fillOpacity]="0"
                    [tableLegend]="false"
                    [strokeWidth]="3"
                    [emptyStateTitle]="'No data available'"
                    [legendDisplayedColumns]="['name']"
                    [colors]="dataSource.endpointsByOsTrend.colors"
                ></app-mdr-dashboards-area-chart>
            </div>
        </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="1">
        <div class="bordered-container align-center">
            <div class="bar-chart-main">
                @if (dataSource.endpointsByOS.data) {
                <app-mdr-dashboards-pie-chart
                    [element]="dataSource.endpointsByOS"
                    [colors]="dataSource.endpointsByOS.colors"
                    [strokeWidth]="4"
                    [donutSize]="'83%'"
                    [width]="250"
                    [height]="190"
                    [tableLegend]="true"
                    [placeLegendBottom]="true"
                    [legendBottomBorder]="true"
                    [pieWidthCoverage]="'100%'"
                ></app-mdr-dashboards-pie-chart>
                }
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource && noIssuesOnboarding !== -1) {
<mat-grid-list
    cols="3"
    rowHeight="{{ 398 + noIssuesOnboarding * 20 }}"
    class="m-t-16 m-b-25"
    gutterSize="16"
>
    <mat-grid-tile colspan="2">
        <div class="bordered-container align-center">
            <div class="bar-chart-main">
                @if (dataSource.statusOfDeployment[0].data) {
                <app-mdr-dashboards-semi-circle-gauge
                    [element]="dataSource.statusOfDeployment"
                    [tableLegend]="true"
                    [containerWidth]="326"
                    [width]="230"
                ></app-mdr-dashboards-semi-circle-gauge>
                }
            </div>
        </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="1">
        <div class="bordered-container align-center">
            <div class="bar-chart-main">
                @if (dataSource.endpointMonitoringStatus.data) {
                <app-mdr-dashboards-pie-chart
                    [element]="dataSource.endpointMonitoringStatus"
                    [colors]="dataSource.endpointMonitoringStatus.colors"
                    [strokeWidth]="4"
                    [donutSize]="'83%'"
                    [width]="250"
                    [height]="190"
                    [tableLegend]="true"
                    [placeLegendBottom]="true"
                    [legendBottomBorder]="true"
                    [legendWidthCoverage]="'100%'"
                    [marginBottomTitle]="'0'"
                    [takeDataFromService]="true"
                ></app-mdr-dashboards-pie-chart>
                }
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
}
